export const publicRoutes: string[] = [
  "/login",
  "/register",
  "/register/confirmation",
  "/otp",
  "/forgot",
  "/error",
  "/shipment-access",
  "/procure/campaigns/discover",
  "/procure/campaigns/discover/:id",
];

export const onboardingRoutes: string[] = [
  "/otp",
  "/onboarding/user",
  "/onboarding/business",
];

export const apiAuthPrefix = "/api/auth";

export const DEFAULT_LOGIN_REDIRECT_PATH = "/procure";
export const DEFAULT_UNAUTHORIZED_REDIRECT_PATH = "/login";
export const CHANGE_PASSWORD_REDIRECT_PATH = "/forgot/new";
